<template>
  <div class="create px-8 py-4">
    <lCrumbs :breadcrumb="breadcrumbItems" />
    <div>
      <div class="mb-8 text-xl text-black">Create Prerequisite</div>
      <div class="mt-12">
        <div class="md:flex w-full">
          <div class="w-full md:w-1/2">
            <div class="md:mx-12">
              <div class="item md:flex md:items-center w-full mb-12">
                <div class="w-full md:w-1/4 ">
                  <label class="text-black font-bold" for=""
                    >Select Type:
                  </label>
                </div>
                <div class="w-full md:w-3/4 ">
                  <LmsSelect
                    :error="errors.target_type"
                    v-model="form.target_type"
                    :items="type"
                    :errorMessage="errors.target_type"
                    placeholder="Select target type"
                  />
                  <small class="text-red-500" v-if="errors.target_type"
                    >This field is required</small
                  >
                </div>
              </div>
            </div>

            <main v-if="form.target_type === 'course'">
              <div class="md:mx-12">
                <div class="item md:flex md:items-center w-full mb-12">
                  <div class="w-full md:w-1/4 ">
                    <label class="text-black font-bold" for=""
                      >Select Target Course:
                    </label>
                  </div>
                  <div class="w-full md:w-3/4 ">
                    <LmsSelect
                      :error="errors.target_id"
                      v-model="form.target_id"
                      :items="sortCourses"
                      :errorMessage="errors.target_id"
                      placeholder="Select Target"
                    />
                    <small class="text-red-500" v-if="errors.target_id"
                      >This field is required</small
                    >
                  </div>
                </div>
              </div>

              <div class="md:mx-12">
                <div class="item md:flex md:items-center w-full mb-12">
                  <div class="w-full md:w-1/4 ">
                    <label class="text-black font-bold" for=""
                      >Select Prerequisite Course:
                    </label>
                  </div>
                  <div class="w-full md:w-3/4 ">
                    <LmsSelect
                      :error="errors.prerequisite_id"
                      v-model="form.prerequisite_id"
                      :items="sortCourses"
                      :errorMessage="errors.prerequisite_id"
                      placeholder="Select Prequiste"
                    />
                    <small class="text-red-500" v-if="errors.prerequisite_id"
                      >This field is required</small
                    >
                  </div>
                </div>
              </div>
            </main>

            <main v-if="form.target_type === 'lesson'">
              <div class="md:mx-12">
                <div class="item md:flex md:items-center w-full mb-12">
                  <div class="w-full md:w-1/4 ">
                    <label class="text-black font-bold" for=""
                      >Select Course:
                    </label>
                  </div>
                  <div class="w-full md:w-3/4 ">
                    <LmsSelect
                      @selected="getLessons($event)"
                      :error="errors.course"
                      v-model="course"
                      selected
                      :items="sortCourses"
                      :errorMessage="errors.course"
                      placeholder="Select Course"
                    />
                    <small class="text-red-500" v-if="errors.target_id"
                      >This field is required</small
                    >
                  </div>
                </div>
              </div>

              <div class="md:mx-12">
                <div class="item md:flex md:items-center w-full mb-12">
                  <div class="w-full md:w-1/4 ">
                    <label class="text-black font-bold" for=""
                      >Select Target Lesson:
                    </label>
                  </div>
                  <div class="w-full md:w-3/4 ">
                    <LmsSelect
                      :error="errors.target_id"
                      v-model="form.target_id"
                      :items="lessons"
                      :errorMessage="errors.target_id"
                      placeholder="Select Prequiste"
                    />
                    <small class="text-red-500" v-if="errors.target_id"
                      >This field is required</small
                    >
                  </div>
                </div>
              </div>

              <div class="md:mx-12">
                <div class="item md:flex md:items-center w-full mb-12">
                  <div class="w-full md:w-1/4 ">
                    <label class="text-black font-bold" for=""
                      >Select Prerequisite Lesson:
                    </label>
                  </div>
                  <div class="w-full md:w-3/4 ">
                    <LmsSelect
                      :error="errors.prerequisite_id"
                      v-model="form.prerequisite_id"
                      :items="lessons"
                      :errorMessage="errors.prerequisite_id"
                      placeholder="Select Prequiste"
                    />
                    <small class="text-red-500" v-if="errors.prerequisite_id"
                      >This field is required</small
                    >
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
      <div class="w-full text-center">
        <lms-button class="mb-12" @click="handleSubmit" textColor="#fff"
          >Create
        </lms-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import FormActions from "@/mixins/FormActions";
export default {
  mixins: [FormActions],
  data() {
    return {
      form: {},
      course: "",
      errors: {},
      lessons: [],
      courses: this.$store.state.learner.courses,
      type: [
        {
          text: "Course Prerequiste",
          value: "course",
        },
        {
          text: "Lesson Prerequiste",
          value: "lesson",
        },
      ],
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/prerequiste",
          text: "All Prerequistes",
        },
        {
          disabled: true,
          to: "/tenant/prerequiste/create",
          text: "Create Prerequiste",
        },
      ],
    };
  },
  components: {
    linput: () => import("@/components/general/input"),
    steps: () => import("@/components/general/steps"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    LmsSelect: () => import("@/components/forms/select"),
  },
  computed: {
    ...mapGetters(["getTenantCourses", "getUser", "getTenantDraftedCourses"]),
    sortCourses() {
      if (!this.getTenantCourses) return;
      let data = [];
      let courses = this.getTenantCourses;
      courses.forEach((course) => {
        let obj = {};
        obj.text = course.title;
        obj.value = course.id;
        data.push(obj);
      });
      return data;
    },
  },
  methods: {
    ...mapActions([
      "tenantCreatePrerequiste",
      "fetchTenantCourses",
      "tenantLessonsInCourse",
    ]),
    async getLessons(e) {
      if (!this.course) return;
      let res = await this.tenantLessonsInCourse({ id: this.course });
      let data = [];
      let lessons = res.data.data.data.lessons.data;
      lessons.forEach((lesson) => {
        let obj = {};
        obj.text = lesson.title;
        obj.value = lesson.id;
        data.push(obj);
      });
      this.lessons = data;
    },
    ...mapMutations(["updateLoader"]),
    async handleSubmit() {
      this.errors = [];
      this.updateLoader(true);
      let res = await this.tenantCreatePrerequiste(this.form);
      this.updateLoader(false);
      if (res.status == 201 || res.status == 200) {
        this.$Bus.$emit("notify", {
          type: "Certificate",
          type: "success",
          message: "Prerequiste created successfully",
        });

        this.$router.push({
          name: "tenant-prerequiste-home",
        });
      } else {
        this.errors = res.data.errors[0].source;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
    async loadData() {
      this.updateLoader(true);
      await this.fetchTenantCourses({ user: this.getUser });
      //console.log({ hhh: this.getTenantCourses });
      this.updateLoader(false);
    },
  },
  mounted() {
    this.$Bus.$on("fetch-courses", (data) => {
      this.loadData();
    });
    this.loadData();
  },
};
</script>
